import { ConfigProvider, Tabs } from "antd";
import "./Tab_Products.scss";
import { MdSubtitles } from "react-icons/md";
import { FaRuler } from "react-icons/fa6";
import { FaTag } from "react-icons/fa";
import { AiOutlineGlobal } from "react-icons/ai";
import { FaNewspaper } from "react-icons/fa6";

function Tab_Products({ productsDetails }) {
  const items = [
    {
      key: "1",
      label: "Mô tả sản phẩm",
      children: (
        <div className="products-des">
          <div className="products-des-title">
            <div className="title">
              <div className="title-icon">
                <MdSubtitles className="icon" />
                <div className="title-name">Tên sản phẩm: </div>
              </div>

              <div className="title-info">{productsDetails[0].title}</div>
            </div>
          </div>

          <div className="products-des-size">
            <div className="size">
              <div className="size-icon">
                <FaRuler className="icon" />
                <div className="size-name">Size:</div>
              </div>

              <div className="size-info">{productsDetails[0].size}</div>
            </div>
          </div>

          <div className="products-des-condition">
            <div className="condition">
              <div className="condition-icon">
                <FaTag className="icon" />
                <div className="condition-name">Tình trạng:</div>
              </div>
              <div className="condition-info">
                {productsDetails[0].condition}
              </div>
            </div>
          </div>

          <div className="products-des-brands">
            <div className="brands">
              <div className="brands-icon">
                <AiOutlineGlobal className="icon" />
                <div className="brands-name">Brand:</div>
              </div>
              <div className="brands-info">{productsDetails[0].name}</div>
            </div>
          </div>

          <div className="products-des-details">
            <div className="details">
              <div className="details-icon">
                <FaNewspaper className="icon" />
                <div className="details-name">Chi tiết:</div>
              </div>
              <div className="details-info">{productsDetails[0].desc}</div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "Chính sách đổi trả",
      children: (
        <div className="policy">
          <div className="policy-one">
            <div className="title">
              I. CAM KẾT CHẤT LƯỢNG & CHÍNH SÁCH BẢO HÀNH
            </div>

            <div className="elements">1. Cam kết chất lượng</div>
            <div className="sub">
              - Sản phẩm 100% hàng chính hãng, hàng secondhand tuyển chọn kỹ.
            </div>
            <div className="sub">
              - Nếu phát hiện hàng Fake, shop hoàn tiền 100% để xin lỗi.
            </div>

            <div className="elements">2. Bảo hành</div>
            <div className="sub">
              - Bảo hành chất lượng trong 30 ngày kể từ lúc khách nhận hàng.
            </div>
            <div className="sub">
              - Hỗ trợ vệ sinh & chăm sóc sản phẩm tùy theo tình trạng thực tế
              (có tính phí nếu vượt ngoài lỗi của shop).
            </div>

            <div className="elements">3. Lưu ý</div>
            <div className="sub">
              - Vui lòng liên hệ trực tiếp với shop trước khi đặt hàng để được
              tư vấn tình trạng sản phẩm, ảnh thật và size chuẩn nhất.
            </div>
          </div>

          <div className="policy-two">
            <div className="title">II. CHÍNH SÁCH ĐỔI – TRẢ</div>

            <div className="elements">
              1. Shop hỗ trợ đổi hàng trong các trường hợp:
            </div>
            <div className="sub">
              - Sản phẩm nhận được bị lỗi, hư hỏng do vận chuyển.
            </div>
            <div className="sub">- Không vừa size hoặc không đúng mô tả.</div>

            <div className="sub">
              - Thuộc phạm vi chính sách đổi trả của shop
            </div>

            <div className="sub">
              - Sản phẩm còn nguyên tình trạng ban đầu, chưa qua sử dụng.
            </div>

            <div className="elements">2. Thời gian đổi trả</div>
            <div className="sub">- Hỗ trợ đổi trả trong vòng 3 ngày.</div>
            <div className="sub">
              - Riêng các trường hợp đổi do lỗi phát sinh ngay khi nhận hàng,
              khách phải liên hệ với shop trong 24 giờ để shop xác nhận và xử lý
              nhanh nhất.
            </div>

            <div className="elements">3. Điều kiện đổi trả</div>
            <div className="sub">
              - Sản phẩm phải còn đầy đủ hộp, phụ kiện, hóa đơn (nếu có).
            </div>

            <div className="sub">
              - Khách hàng chịu chi phí vận chuyển (hai chiều) trong trường hợp
              đổi size hoặc đổi vì lý do cá nhân.
            </div>

            <div className="sub">
              - Nếu sản phẩm lỗi thuộc về shop thì shop chịu toàn bộ chi phí vận
              chuyển.
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="tabs">
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemSelectedColor: "#fff",
                itemColor: "#000",
                itemHoverColor: "#555",
              },
            },
          }}
        >
          <Tabs type="card" defaultActiveKey="1" items={items} />
        </ConfigProvider>
      </div>
    </>
  );
}

export default Tab_Products;
